import { render, staticRenderFns } from "./AdminManageLocation.vue?vue&type=template&id=2d1bc735"
import script from "./AdminManageLocation.vue?vue&type=script&lang=js"
export * from "./AdminManageLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports